import { STRING_OPERATOR_OPTIONS } from 'core/table/interfaces/Filters'

export { AUTOMATED_MESSAGES_DATE_RANGE_KEY, MESSAGES_LIST_DEFAULT_DATE_RANGE } from '../config'

export const AUTOMATED_MESSAGES_TABLE_NAME = 'automatedMessages'

export const AUTOMATED_MESSAGES_CSV_HEADERS = [
  { label: 'Subject', key: 'subject' },
  { label: 'Date', key: 'createdAt' },
  { label: 'Source', key: 'source' },
  { label: 'Source Name', key: 'sourceName' },
  { label: 'Status', key: 'status' },
]

export const getAutomatedMessagesOperatorOptions = (column: string) => {
  switch (column) {
    case 'subject':
      return STRING_OPERATOR_OPTIONS
    default:
      return []
  }
}
